export interface EmbedReportModel {
    reportId: string,
    reportName: string,
    embedUrl: string,
    pageName: string
}

export const embedReportModelInitial: EmbedReportModel = {
    reportId: '',
    reportName: '',
    embedUrl: '',
    pageName: ''
};